import { render, staticRenderFns } from "./VirementP2p.vue?vue&type=template&id=04196513&"
import script from "./VirementP2p.vue?vue&type=script&lang=js&"
export * from "./VirementP2p.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VirementP2p.vue"
export default component.exports